import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import { Quotes } from '@assets/icons'
import { Body2, H4 } from '@components/Typography'

import * as HomeStyle from '../../Home.style'
import * as CommentsStyle from './Comments.style'

export default function Comments() {
  return (
    <CommentsStyle.Wrapper>
      <HomeStyle.Container>
        <Row>
          <Col xxs={12} xl={4}>
            <CommentsStyle.Title>
              <FormattedMessage id="smb_acquisition_home.testimonials.title" />
            </CommentsStyle.Title>
          </Col>

          <Col xxs={12} xl={4}>
            <CommentsStyle.Item>
              <CommentsStyle.Icon src={Quotes} alt="Abre aspas" />
              <CommentsStyle.Description>
                <FormattedMessage id="smb_acquisition_home.testimonials.testimony_1.text" />
                &quot;
              </CommentsStyle.Description>
              <CommentsStyle.Author>
                <H4>
                  <FormattedMessage id="smb_acquisition_home.testimonials.testimony_1.author" />
                </H4>
                <Body2>
                  <FormattedMessage id="smb_acquisition_home.testimonials.testimony_1.position" />
                </Body2>
              </CommentsStyle.Author>
            </CommentsStyle.Item>
          </Col>

          <Col xxs={12} xl={4}>
            <CommentsStyle.Item>
              <CommentsStyle.Icon src={Quotes} alt="Abre aspas" />
              <CommentsStyle.Description>
                <FormattedMessage id="smb_acquisition_home.testimonials.testimony_2.text" />
                &quot;
              </CommentsStyle.Description>
              <CommentsStyle.Author>
                <H4>
                  <FormattedMessage id="smb_acquisition_home.testimonials.testimony_2.author" />
                </H4>
                <Body2>
                  <FormattedMessage id="smb_acquisition_home.testimonials.testimony_2.position" />
                </Body2>
              </CommentsStyle.Author>
            </CommentsStyle.Item>
          </Col>
        </Row>
      </HomeStyle.Container>
    </CommentsStyle.Wrapper>
  )
}
